<template>

    <div class="row row-cols-2 row-cols-sm-4 row-cols-lg-5 g-4 align-items-center justify-content-center mb-5">
        <div class="col text-center" v-for="supplier in featuredSuppliers">
            <inertia-link :href="supplier.permalink">
                <img :src="supplier.logo" :alt="supplier.name" class="img-fluid" style="max-height: 40px;" />
            </inertia-link>
        </div>
    </div> 

</template>

<script>
    export default {
        props: [
            'featuredSuppliers'
        ],
    }
</script>

<style scoped>

</style>